import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { InventoryKindRepositoryBase } from '@skylab-shared/business';
export { InventoryKindRepositoryBase };

@Injectable({ providedIn: 'root' })
@Wrapper(InventoryKindRepositoryBase)
export class InventoryKindRepository {
    public constructor(
        weaver: Weaver,
        http: Http
    ) { }
}
